var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_66903",
    "data-name": "Group 66903",
    transform: "translate(7.933 -10)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2378",
    "data-name": "Ellipse 2378",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(-7.933 10)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "phone-call",
    transform: "translate(-1.005 17.449)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66315",
    "data-name": "Group 66315",
    transform: "translate(0.539 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77730",
    "data-name": "Path 77730",
    d: "M17.158,12.551l-2.387-2.387a1.587,1.587,0,0,0-2.642.6,1.624,1.624,0,0,1-1.875,1.023A7.36,7.36,0,0,1,5.821,7.352,1.545,1.545,0,0,1,6.844,5.477a1.587,1.587,0,0,0,.6-2.642L5.054.448a1.7,1.7,0,0,0-2.3,0l-1.62,1.62C-.486,3.772,1.3,8.289,5.31,12.3s8.524,5.881,10.229,4.177l1.62-1.62A1.7,1.7,0,0,0,17.158,12.551Z",
    transform: "translate(-0.539 0)",
    fill: "#929292"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactPhoneIcon);
export default __webpack_public_path__ + "static/media/contactPhoneIcon.d7e1b49b4d6426a7c12bdb3a849fa8f2.svg";
export { ForwardRef as ReactComponent };